import React from "react";
import { Box, Typography, Link, Container } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: "black",
        color: "white",
        py: 1,
        mt: "auto",
      }}
    >
      <Container maxWidth="auto">
        <Typography variant="body2" align="center" gutterBottom>
          © {new Date().getFullYear()} MikeSoft. Todos los derechos reservados.
        </Typography>
        <Typography variant="body2" align="center">
          Diseñado por{" "}
          <Link href="https://tusitio.com" color="secondary" underline="hover">
            Miguel Callizaya
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
